import type { FC } from 'react';

interface Props {
  className?: string;
}

const EvChargingIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M13 10V3L4 14h7v7l9-11h-7z"
      />
      <rect x="2" y="18" width="20" height="3" rx="1" strokeWidth="2" />
    </svg>
  );
};

export default EvChargingIcon;
